import { useEffect, useState } from "react";
import type { Session } from "@supabase/supabase-js";
import { LoaderCircle } from "lucide-react";
import { AuthScreen } from "./components/AuthScreen";
import { Dashboard } from "./components/Dashboard";
import { isSupabaseConfigured, supabase } from "./lib/supabase";

export default function App() {
  const [session, setSession] = useState<Session | null>(null);
  const [checking, setChecking] = useState(isSupabaseConfigured);
  const [recoveringPassword, setRecoveringPassword] = useState(
    () => new URLSearchParams(window.location.hash.slice(1)).get("type") === "recovery",
  );

  useEffect(() => {
    if (!supabase) return;

    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setChecking(false);
    });

    const { data } = supabase.auth.onAuthStateChange((event, nextSession) => {
      if (event === "PASSWORD_RECOVERY") setRecoveringPassword(true);
      setSession(nextSession);
      setChecking(false);
    });

    return () => data.subscription.unsubscribe();
  }, []);

  if (checking) {
    return (
      <main className="fullscreen-loader">
        <LoaderCircle className="spin" size={34} />
        <span>Validando acesso…</span>
      </main>
    );
  }

  if (isSupabaseConfigured && (recoveringPassword || !session)) {
    return (
      <AuthScreen
        initialView={recoveringPassword ? "update-password" : "login"}
        onRecoveryComplete={() => {
          setRecoveringPassword(false);
          window.history.replaceState({}, "", window.location.pathname);
        }}
      />
    );
  }
  return <Dashboard />;
}
